import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
};

export type AppBillingBalance = {
  __typename?: 'AppBillingBalance';
  balance: Scalars['Float']['output'];
  operationType: BillableOperationType;
};

export type AppBillingCustomer = {
  __typename?: 'AppBillingCustomer';
  address?: Maybe<AppBillingCustomerAddress>;
  currency: Scalars['ID']['output'];
  customerId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  taxIds?: Maybe<Array<AppBillingCustomerTaxId>>;
  userId: Scalars['ID']['output'];
};

export type AppBillingCustomerAddress = {
  __typename?: 'AppBillingCustomerAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AppBillingCustomerAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AppBillingCustomerResult = {
  __typename?: 'AppBillingCustomerResult';
  customer?: Maybe<AppBillingCustomer>;
  stripeError?: Maybe<AppBillingStripeError>;
};

export type AppBillingCustomerTaxId = {
  __typename?: 'AppBillingCustomerTaxId';
  type: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type AppBillingCustomerTaxIdInput = {
  type: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type AppBillingInvoice = {
  __typename?: 'AppBillingInvoice';
  currency: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  invoicePdf?: Maybe<Scalars['String']['output']>;
  items: Array<AppBillingInvoiceItem>;
  paymentIntent?: Maybe<AppBillingPaymentIntent>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['ID']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
};

export type AppBillingInvoiceItem = {
  __typename?: 'AppBillingInvoiceItem';
  amount: Scalars['Float']['output'];
  currency: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  price: AppBillingProductPrice;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  warehouseId?: Maybe<Scalars['ID']['output']>;
};

export type AppBillingOperation = {
  __typename?: 'AppBillingOperation';
  balanceChanged?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  operationType?: Maybe<BillableOperationType>;
  paymentSource?: Maybe<AppBillingOperationPaymentSource>;
  purchaseId?: Maybe<Scalars['ID']['output']>;
  serviceType: BillableServiceType;
  status: AppBillingOperationStatus;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  subscriptionPeriodEnd?: Maybe<Scalars['Timestamp']['output']>;
  subscriptionStatus?: Maybe<AppBillingSubscriptionStatus>;
  trackedOperationId?: Maybe<Scalars['ID']['output']>;
  trialEnd?: Maybe<Scalars['Timestamp']['output']>;
  trialStatus?: Maybe<AppBillingWarehouseTrialStatus>;
  type: AppBillingOperationType;
  updatedAt: Scalars['Timestamp']['output'];
  usage?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  warehouseId: Scalars['ID']['output'];
};

export type AppBillingOperationFilter = {
  serviceType?: InputMaybe<Array<BillableServiceType>>;
  status?: InputMaybe<Array<AppBillingOperationStatus>>;
  type?: InputMaybe<Array<AppBillingOperationType>>;
  warehouseId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AppBillingOperationPaymentSource {
  BALANCE = 'BALANCE',
  BALANCE_INCLUDED = 'BALANCE_INCLUDED',
  SUBSCRIPTION = 'SUBSCRIPTION',
  SUBSCRIPTION_INCLUDED = 'SUBSCRIPTION_INCLUDED',
  TRIAL = 'TRIAL'
}

export enum AppBillingOperationStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING'
}

export enum AppBillingOperationType {
  PURCHASE = 'PURCHASE',
  SUBSCRIPTION_CHANGED = 'SUBSCRIPTION_CHANGED',
  TRIAL_CHANGED = 'TRIAL_CHANGED',
  USAGE = 'USAGE'
}

export type AppBillingOperationsConnection = {
  __typename?: 'AppBillingOperationsConnection';
  /** Content of collection or the current page of collection if pagination is used */
  content: Array<AppBillingOperation>;
  /** Total number of elements in this collection (ignoring pagination constraints, if any) */
  totalCount: Scalars['Float']['output'];
};

export type AppBillingOperationsSortBy = {
  /** Sorting direction */
  direction?: SortDirection;
  /** Field (sort option) to sort by */
  field: AuditableEntitySortOption;
};

export type AppBillingPaymentIntent = {
  __typename?: 'AppBillingPaymentIntent';
  clientSecret: Scalars['String']['output'];
  status: Scalars['ID']['output'];
};

export type AppBillingProduct = {
  __typename?: 'AppBillingProduct';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  operationCount?: Maybe<Scalars['Float']['output']>;
  operationType: BillableOperationType;
  prices: Array<AppBillingProductPrice>;
  productCategory: AppBillingProductCategory;
  warehouseSize: WarehouseSize;
};

export enum AppBillingProductCategory {
  BUNDLE = 'BUNDLE',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export type AppBillingProductPrice = {
  __typename?: 'AppBillingProductPrice';
  currency: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  raw: Scalars['JSON']['output'];
  subscriptionDetails?: Maybe<AppBillingSubscriptionPriceDetails>;
  unitAmount: Scalars['Float']['output'];
};

export type AppBillingPurchase = {
  __typename?: 'AppBillingPurchase';
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  finalizedAt?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<AppBillingInvoice>;
  paidAt?: Maybe<Scalars['Timestamp']['output']>;
  status: AppBillingPurchaseStatus;
  stripePublishableKey: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  userId: Scalars['ID']['output'];
  warehouseIds: Array<Scalars['ID']['output']>;
};

export type AppBillingPurchaseFilter = {
  status?: InputMaybe<Array<AppBillingPurchaseStatus>>;
  warehouseId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AppBillingPurchaseResult = {
  __typename?: 'AppBillingPurchaseResult';
  purchase?: Maybe<AppBillingPurchase>;
  stripeError?: Maybe<AppBillingStripeError>;
};

export enum AppBillingPurchaseStatus {
  CANCELLED = 'CANCELLED',
  CREATED = 'CREATED',
  DRAFT = 'DRAFT',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  OPEN = 'OPEN',
  PAID = 'PAID'
}

export type AppBillingPurchasesConnection = {
  __typename?: 'AppBillingPurchasesConnection';
  /** Content of collection or the current page of collection if pagination is used */
  content: Array<AppBillingPurchase>;
  /** Total number of elements in this collection (ignoring pagination constraints, if any) */
  totalCount: Scalars['Float']['output'];
};

export type AppBillingPurchasesSortBy = {
  /** Sorting direction */
  direction?: SortDirection;
  /** Field (sort option) to sort by */
  field: AuditableEntitySortOption;
};

export type AppBillingStripeError = {
  __typename?: 'AppBillingStripeError';
  code?: Maybe<Scalars['String']['output']>;
  declineCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  param?: Maybe<Scalars['String']['output']>;
  type: Scalars['ID']['output'];
};

export type AppBillingSubscription = {
  __typename?: 'AppBillingSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  createdAt: Scalars['Timestamp']['output'];
  currentPeriodEnd?: Maybe<Scalars['Timestamp']['output']>;
  currentPeriodStart?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestInvoice?: Maybe<AppBillingInvoice>;
  serviceType: BillableServiceType;
  status: AppBillingSubscriptionStatus;
  stripePublishableKey: Scalars['String']['output'];
  subscriptionType: BillableOperationType;
  upcomingInvoice?: Maybe<AppBillingInvoice>;
  updatedAt: Scalars['Timestamp']['output'];
  userId: Scalars['ID']['output'];
  warehouseId: Scalars['ID']['output'];
  warehouseSize: WarehouseSize;
};

export type AppBillingSubscriptionFilter = {
  status?: InputMaybe<Array<AppBillingSubscriptionStatus>>;
  warehouseId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AppBillingSubscriptionPriceDetails = {
  __typename?: 'AppBillingSubscriptionPriceDetails';
  interval: Scalars['ID']['output'];
  intervalCount: Scalars['Float']['output'];
};

export type AppBillingSubscriptionResult = {
  __typename?: 'AppBillingSubscriptionResult';
  stripeError?: Maybe<AppBillingStripeError>;
  subscription?: Maybe<AppBillingSubscription>;
};

export enum AppBillingSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  CREATED = 'CREATED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  PAST_DUE = 'PAST_DUE',
  TRIALING = 'TRIALING',
  UNPAID = 'UNPAID'
}

export type AppBillingSubscriptionsConnection = {
  __typename?: 'AppBillingSubscriptionsConnection';
  /** Content of collection or the current page of collection if pagination is used */
  content: Array<AppBillingSubscription>;
  /** Total number of elements in this collection (ignoring pagination constraints, if any) */
  totalCount: Scalars['Float']['output'];
};

export type AppBillingSubscriptionsSortBy = {
  /** Sorting direction */
  direction?: SortDirection;
  /** Field (sort option) to sort by */
  field: AuditableEntitySortOption;
};

export type AppBillingWarehouseState = {
  __typename?: 'AppBillingWarehouseState';
  activeTrials: Array<AppBillingWarehouseTrial>;
  allowedOperations: Array<BillableOperationType>;
  balance: Array<AppBillingBalance>;
  currentSubscriptions: Array<AppBillingSubscription>;
  warehouseId: Scalars['ID']['output'];
};

export type AppBillingWarehouseTrial = {
  __typename?: 'AppBillingWarehouseTrial';
  allowedOperations: Array<BillableOperationType>;
  createdAt: Scalars['Timestamp']['output'];
  serviceType: BillableServiceType;
  status: AppBillingWarehouseTrialStatus;
  trialEnd: Scalars['Timestamp']['output'];
  trialStart: Scalars['Timestamp']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  warehouseId: Scalars['ID']['output'];
};

export enum AppBillingWarehouseTrialStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  ENDED = 'ENDED'
}

export enum AuditableEntitySortOption {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT'
}

export enum BillableOperationType {
  ANALYZE = 'ANALYZE',
  OPTIMIZE = 'OPTIMIZE'
}

export enum BillableServiceType {
  PLANNING = 'PLANNING'
}

export type CreateAppBillingPurchaseInput = {
  currency: Scalars['ID']['input'];
  finalize?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<CreateAppBillingPurchaseItemInput>;
};

export type CreateAppBillingPurchaseItemInput = {
  priceId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  warehouseToken: Scalars['String']['input'];
};

export type CreateAppBillingSubscriptionInput = {
  priceId: Scalars['ID']['input'];
  warehouseToken: Scalars['String']['input'];
};

export type CreateOrUpdateAppBillingCustomerInput = {
  address?: InputMaybe<AppBillingCustomerAddressInput>;
  currency: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxIds?: InputMaybe<Array<AppBillingCustomerTaxIdInput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAppBillingPurchase: AppBillingPurchaseResult;
  createAppBillingSubscription: AppBillingSubscriptionResult;
  createOrUpdateAppBillingCustomer: AppBillingCustomerResult;
  finalizeAppBillingPurchase: AppBillingPurchaseResult;
};


export type MutationCreateAppBillingPurchaseArgs = {
  input: CreateAppBillingPurchaseInput;
};


export type MutationCreateAppBillingSubscriptionArgs = {
  input: CreateAppBillingSubscriptionInput;
};


export type MutationCreateOrUpdateAppBillingCustomerArgs = {
  input: CreateOrUpdateAppBillingCustomerInput;
};


export type MutationFinalizeAppBillingPurchaseArgs = {
  id: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  appBillingOperations: AppBillingOperationsConnection;
  appBillingProducts: Array<AppBillingProduct>;
  appBillingPurchase?: Maybe<AppBillingPurchase>;
  appBillingPurchases: AppBillingPurchasesConnection;
  appBillingSubscription?: Maybe<AppBillingSubscription>;
  appBillingSubscriptions: AppBillingSubscriptionsConnection;
  appBillingWarehouseState?: Maybe<AppBillingWarehouseState>;
  appBillingWarehouseStates: Array<AppBillingWarehouseState>;
  currentAppBillingCustomer?: Maybe<Array<AppBillingCustomer>>;
};


export type QueryAppBillingOperationsArgs = {
  filter?: InputMaybe<AppBillingOperationFilter>;
  page?: InputMaybe<SkipLimitPageSpec>;
  sortBy?: InputMaybe<Array<AppBillingOperationsSortBy>>;
};


export type QueryAppBillingProductsArgs = {
  category?: InputMaybe<Array<AppBillingProductCategory>>;
  currency?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAppBillingPurchaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryAppBillingPurchasesArgs = {
  filter?: InputMaybe<AppBillingPurchaseFilter>;
  page?: InputMaybe<SkipLimitPageSpec>;
  sortBy?: InputMaybe<Array<AppBillingPurchasesSortBy>>;
};


export type QueryAppBillingSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryAppBillingSubscriptionsArgs = {
  filter?: InputMaybe<AppBillingSubscriptionFilter>;
  page?: InputMaybe<SkipLimitPageSpec>;
  sortBy?: InputMaybe<Array<AppBillingSubscriptionsSortBy>>;
};


export type QueryAppBillingWarehouseStateArgs = {
  warehouseToken: Scalars['String']['input'];
};


export type QueryAppBillingWarehouseStatesArgs = {
  warehouseTokens: Array<Scalars['ID']['input']>;
};


export type QueryCurrentAppBillingCustomerArgs = {
  currency?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Pagination specification with 'skip' and 'limit' values */
export type SkipLimitPageSpec = {
  /** Max number of objects to retrieve */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Number of objects to skip */
  skip?: InputMaybe<Scalars['Float']['input']>;
};

/** Sorting direction */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum WarehouseSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export type AppBillingCustomerAddressFragment = { __typename?: 'AppBillingCustomerAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null };

export type AppBillingCustomerTaxIdFragment = { __typename?: 'AppBillingCustomerTaxId', type: string, value: string };

export type AppBillingCustomerFragment = { __typename?: 'AppBillingCustomer', currency: string, email?: string | null, name?: string | null, phone?: string | null, description?: string | null, address?: { __typename?: 'AppBillingCustomerAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, taxIds?: Array<{ __typename?: 'AppBillingCustomerTaxId', type: string, value: string }> | null };

export type LoadCurrentAppBillingCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCurrentAppBillingCustomerQuery = { __typename?: 'Query', currentAppBillingCustomer?: Array<{ __typename?: 'AppBillingCustomer', currency: string, email?: string | null, name?: string | null, phone?: string | null, description?: string | null, address?: { __typename?: 'AppBillingCustomerAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, taxIds?: Array<{ __typename?: 'AppBillingCustomerTaxId', type: string, value: string }> | null }> | null };

export type CreateOrUpdateAppBillingCustomerMutationVariables = Exact<{
  input: CreateOrUpdateAppBillingCustomerInput;
}>;


export type CreateOrUpdateAppBillingCustomerMutation = { __typename?: 'Mutation', createOrUpdateAppBillingCustomer: { __typename?: 'AppBillingCustomerResult', customer?: { __typename?: 'AppBillingCustomer', currency: string, email?: string | null, name?: string | null, phone?: string | null, description?: string | null, address?: { __typename?: 'AppBillingCustomerAddress', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postalCode?: string | null, state?: string | null } | null, taxIds?: Array<{ __typename?: 'AppBillingCustomerTaxId', type: string, value: string }> | null } | null, stripeError?: { __typename?: 'AppBillingStripeError', type: string, code?: string | null, declineCode?: string | null, message?: string | null, param?: string | null } | null } };

export type AppBillingStripeErrorFragment = { __typename?: 'AppBillingStripeError', type: string, code?: string | null, declineCode?: string | null, message?: string | null, param?: string | null };

export type AppBillingPaymentIntentFragment = { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string };

export type AppBillingInvoiceItemFragment = { __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } };

export type AppBillingInvoiceFragment = { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null };

export type AppBillingProductPriceFragment = { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null };

export type AppBillingProductFragment = { __typename?: 'AppBillingProduct', id: string, name: string, description?: string | null, productCategory: AppBillingProductCategory, warehouseSize: WarehouseSize, operationType: BillableOperationType, operationCount?: number | null, metadata: any, prices: Array<{ __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null }> };

export type LoadAppBillingProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadAppBillingProductsQuery = { __typename?: 'Query', appBillingProducts: Array<{ __typename?: 'AppBillingProduct', id: string, name: string, description?: string | null, productCategory: AppBillingProductCategory, warehouseSize: WarehouseSize, operationType: BillableOperationType, operationCount?: number | null, metadata: any, prices: Array<{ __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null }> }> };

export type AppBillingPurchaseFragment = { __typename?: 'AppBillingPurchase', id: string, title?: string | null, description?: string | null, status: AppBillingPurchaseStatus, paidAt?: any | null, createdAt: any, stripePublishableKey: string, invoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null };

export type CreateAppBillingPurchaseMutationVariables = Exact<{
  input: CreateAppBillingPurchaseInput;
}>;


export type CreateAppBillingPurchaseMutation = { __typename?: 'Mutation', createAppBillingPurchase: { __typename?: 'AppBillingPurchaseResult', purchase?: { __typename?: 'AppBillingPurchase', id: string, title?: string | null, description?: string | null, status: AppBillingPurchaseStatus, paidAt?: any | null, createdAt: any, stripePublishableKey: string, invoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null } | null, stripeError?: { __typename?: 'AppBillingStripeError', type: string, code?: string | null, declineCode?: string | null, message?: string | null, param?: string | null } | null } };

export type LoadAppBillingPurchaseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LoadAppBillingPurchaseQuery = { __typename?: 'Query', appBillingPurchase?: { __typename?: 'AppBillingPurchase', id: string, title?: string | null, description?: string | null, status: AppBillingPurchaseStatus, paidAt?: any | null, createdAt: any, stripePublishableKey: string, invoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null } | null };

export type LoadAppBillingPurchasesQueryVariables = Exact<{
  whId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type LoadAppBillingPurchasesQuery = { __typename?: 'Query', appBillingPurchases: { __typename?: 'AppBillingPurchasesConnection', content: Array<{ __typename?: 'AppBillingPurchase', id: string, title?: string | null, description?: string | null, status: AppBillingPurchaseStatus, paidAt?: any | null, createdAt: any, stripePublishableKey: string, invoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null }> } };

export type AppBillingSubscriptionFragment = { __typename?: 'AppBillingSubscription', id: string, description?: string | null, warehouseId: string, userId: string, serviceType: BillableServiceType, subscriptionType: BillableOperationType, warehouseSize: WarehouseSize, status: AppBillingSubscriptionStatus, createdAt: any, updatedAt: any, cancelAtPeriodEnd: boolean, stripePublishableKey: string, latestInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null, upcomingInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null };

export type CreateAppBillingSubscriptionMutationVariables = Exact<{
  input: CreateAppBillingSubscriptionInput;
}>;


export type CreateAppBillingSubscriptionMutation = { __typename?: 'Mutation', createAppBillingSubscription: { __typename?: 'AppBillingSubscriptionResult', subscription?: { __typename?: 'AppBillingSubscription', id: string, description?: string | null, warehouseId: string, userId: string, serviceType: BillableServiceType, subscriptionType: BillableOperationType, warehouseSize: WarehouseSize, status: AppBillingSubscriptionStatus, createdAt: any, updatedAt: any, cancelAtPeriodEnd: boolean, stripePublishableKey: string, latestInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null, upcomingInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null } | null, stripeError?: { __typename?: 'AppBillingStripeError', type: string, code?: string | null, declineCode?: string | null, message?: string | null, param?: string | null } | null } };

export type LoadAppBillingSubscriptionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LoadAppBillingSubscriptionQuery = { __typename?: 'Query', appBillingSubscription?: { __typename?: 'AppBillingSubscription', id: string, description?: string | null, warehouseId: string, userId: string, serviceType: BillableServiceType, subscriptionType: BillableOperationType, warehouseSize: WarehouseSize, status: AppBillingSubscriptionStatus, createdAt: any, updatedAt: any, cancelAtPeriodEnd: boolean, stripePublishableKey: string, latestInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null, upcomingInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null } | null };

export type LoadAppBillingSubscriptionsQueryVariables = Exact<{
  whId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type LoadAppBillingSubscriptionsQuery = { __typename?: 'Query', appBillingSubscriptions: { __typename?: 'AppBillingSubscriptionsConnection', content: Array<{ __typename?: 'AppBillingSubscription', id: string, description?: string | null, warehouseId: string, userId: string, serviceType: BillableServiceType, subscriptionType: BillableOperationType, warehouseSize: WarehouseSize, status: AppBillingSubscriptionStatus, createdAt: any, updatedAt: any, cancelAtPeriodEnd: boolean, stripePublishableKey: string, latestInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null, upcomingInvoice?: { __typename?: 'AppBillingInvoice', title?: string | null, description?: string | null, status: string, currency: string, tax?: number | null, total: number, invoicePdf?: string | null, hostedInvoiceUrl?: string | null, receiptUrl?: string | null, items: Array<{ __typename?: 'AppBillingInvoiceItem', id: string, description?: string | null, productId: string, warehouseId?: string | null, quantity: number, amount: number, currency: string, price: { __typename?: 'AppBillingProductPrice', currency: string, id: string, metadata: any, unitAmount: number, subscriptionDetails?: { __typename?: 'AppBillingSubscriptionPriceDetails', interval: string, intervalCount: number } | null } }>, paymentIntent?: { __typename?: 'AppBillingPaymentIntent', status: string, clientSecret: string } | null } | null }> } };

export type AppBillingWarehouseStateFragment = { __typename?: 'AppBillingWarehouseState', warehouseId: string, allowedOperations: Array<BillableOperationType>, balance: Array<{ __typename?: 'AppBillingBalance', operationType: BillableOperationType, balance: number }>, currentSubscriptions: Array<{ __typename?: 'AppBillingSubscription', id: string, status: AppBillingSubscriptionStatus, serviceType: BillableServiceType, subscriptionType: BillableOperationType, currentPeriodEnd?: any | null }>, activeTrials: Array<{ __typename?: 'AppBillingWarehouseTrial', allowedOperations: Array<BillableOperationType>, serviceType: BillableServiceType, trialStart: any, trialEnd: any }> };

export type LoadBillingStateQueryVariables = Exact<{
  warehouseTokens: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type LoadBillingStateQuery = { __typename?: 'Query', appBillingWarehouseStates: Array<{ __typename?: 'AppBillingWarehouseState', warehouseId: string, allowedOperations: Array<BillableOperationType>, balance: Array<{ __typename?: 'AppBillingBalance', operationType: BillableOperationType, balance: number }>, currentSubscriptions: Array<{ __typename?: 'AppBillingSubscription', id: string, status: AppBillingSubscriptionStatus, serviceType: BillableServiceType, subscriptionType: BillableOperationType, currentPeriodEnd?: any | null }>, activeTrials: Array<{ __typename?: 'AppBillingWarehouseTrial', allowedOperations: Array<BillableOperationType>, serviceType: BillableServiceType, trialStart: any, trialEnd: any }> }> };

export const AppBillingCustomerAddressFragmentDoc = gql`
    fragment AppBillingCustomerAddress on AppBillingCustomerAddress {
  city
  country
  line1
  line2
  postalCode
  state
}
    `;
export const AppBillingCustomerTaxIdFragmentDoc = gql`
    fragment AppBillingCustomerTaxId on AppBillingCustomerTaxId {
  type
  value
}
    `;
export const AppBillingCustomerFragmentDoc = gql`
    fragment AppBillingCustomer on AppBillingCustomer {
  currency
  email
  name
  phone
  description
  address {
    ...AppBillingCustomerAddress
  }
  taxIds {
    ...AppBillingCustomerTaxId
  }
}
    ${AppBillingCustomerAddressFragmentDoc}
${AppBillingCustomerTaxIdFragmentDoc}`;
export const AppBillingStripeErrorFragmentDoc = gql`
    fragment AppBillingStripeError on AppBillingStripeError {
  type
  code
  declineCode
  message
  param
}
    `;
export const AppBillingProductPriceFragmentDoc = gql`
    fragment AppBillingProductPrice on AppBillingProductPrice {
  currency
  id
  metadata
  subscriptionDetails {
    interval
    intervalCount
  }
  unitAmount
}
    `;
export const AppBillingProductFragmentDoc = gql`
    fragment AppBillingProduct on AppBillingProduct {
  id
  name
  description
  productCategory
  warehouseSize
  operationType
  operationCount
  metadata
  prices {
    ...AppBillingProductPrice
  }
}
    ${AppBillingProductPriceFragmentDoc}`;
export const AppBillingInvoiceItemFragmentDoc = gql`
    fragment AppBillingInvoiceItem on AppBillingInvoiceItem {
  id
  description
  productId
  warehouseId
  price {
    ...AppBillingProductPrice
  }
  quantity
  amount
  currency
}
    ${AppBillingProductPriceFragmentDoc}`;
export const AppBillingPaymentIntentFragmentDoc = gql`
    fragment AppBillingPaymentIntent on AppBillingPaymentIntent {
  status
  clientSecret
}
    `;
export const AppBillingInvoiceFragmentDoc = gql`
    fragment AppBillingInvoice on AppBillingInvoice {
  title
  description
  status
  items {
    ...AppBillingInvoiceItem
  }
  currency
  tax
  total
  invoicePdf
  hostedInvoiceUrl
  receiptUrl
  paymentIntent {
    ...AppBillingPaymentIntent
  }
}
    ${AppBillingInvoiceItemFragmentDoc}
${AppBillingPaymentIntentFragmentDoc}`;
export const AppBillingPurchaseFragmentDoc = gql`
    fragment AppBillingPurchase on AppBillingPurchase {
  id
  title
  description
  status
  paidAt
  createdAt
  invoice {
    ...AppBillingInvoice
  }
  stripePublishableKey
}
    ${AppBillingInvoiceFragmentDoc}`;
export const AppBillingSubscriptionFragmentDoc = gql`
    fragment AppBillingSubscription on AppBillingSubscription {
  id
  description
  warehouseId
  userId
  serviceType
  subscriptionType
  warehouseSize
  status
  latestInvoice {
    ...AppBillingInvoice
  }
  upcomingInvoice {
    ...AppBillingInvoice
  }
  createdAt
  updatedAt
  cancelAtPeriodEnd
  stripePublishableKey
}
    ${AppBillingInvoiceFragmentDoc}`;
export const AppBillingWarehouseStateFragmentDoc = gql`
    fragment AppBillingWarehouseState on AppBillingWarehouseState {
  warehouseId
  balance {
    operationType
    balance
  }
  currentSubscriptions {
    id
    status
    serviceType
    subscriptionType
    currentPeriodEnd
  }
  activeTrials {
    allowedOperations
    serviceType
    trialStart
    trialEnd
  }
  allowedOperations
}
    `;
export const LoadCurrentAppBillingCustomerDocument = gql`
    query loadCurrentAppBillingCustomer {
  currentAppBillingCustomer {
    ...AppBillingCustomer
  }
}
    ${AppBillingCustomerFragmentDoc}`;

/**
 * __useLoadCurrentAppBillingCustomerQuery__
 *
 * To run a query within a React component, call `useLoadCurrentAppBillingCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCurrentAppBillingCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCurrentAppBillingCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadCurrentAppBillingCustomerQuery(baseOptions?: Apollo.QueryHookOptions<LoadCurrentAppBillingCustomerQuery, LoadCurrentAppBillingCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadCurrentAppBillingCustomerQuery, LoadCurrentAppBillingCustomerQueryVariables>(LoadCurrentAppBillingCustomerDocument, options);
      }
export function useLoadCurrentAppBillingCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadCurrentAppBillingCustomerQuery, LoadCurrentAppBillingCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadCurrentAppBillingCustomerQuery, LoadCurrentAppBillingCustomerQueryVariables>(LoadCurrentAppBillingCustomerDocument, options);
        }
export function useLoadCurrentAppBillingCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoadCurrentAppBillingCustomerQuery, LoadCurrentAppBillingCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadCurrentAppBillingCustomerQuery, LoadCurrentAppBillingCustomerQueryVariables>(LoadCurrentAppBillingCustomerDocument, options);
        }
export type LoadCurrentAppBillingCustomerQueryHookResult = ReturnType<typeof useLoadCurrentAppBillingCustomerQuery>;
export type LoadCurrentAppBillingCustomerLazyQueryHookResult = ReturnType<typeof useLoadCurrentAppBillingCustomerLazyQuery>;
export type LoadCurrentAppBillingCustomerSuspenseQueryHookResult = ReturnType<typeof useLoadCurrentAppBillingCustomerSuspenseQuery>;
export type LoadCurrentAppBillingCustomerQueryResult = Apollo.QueryResult<LoadCurrentAppBillingCustomerQuery, LoadCurrentAppBillingCustomerQueryVariables>;
export const CreateOrUpdateAppBillingCustomerDocument = gql`
    mutation createOrUpdateAppBillingCustomer($input: CreateOrUpdateAppBillingCustomerInput!) {
  createOrUpdateAppBillingCustomer(input: $input) {
    customer {
      ...AppBillingCustomer
    }
    stripeError {
      ...AppBillingStripeError
    }
  }
}
    ${AppBillingCustomerFragmentDoc}
${AppBillingStripeErrorFragmentDoc}`;
export type CreateOrUpdateAppBillingCustomerMutationFn = Apollo.MutationFunction<CreateOrUpdateAppBillingCustomerMutation, CreateOrUpdateAppBillingCustomerMutationVariables>;

/**
 * __useCreateOrUpdateAppBillingCustomerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAppBillingCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAppBillingCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAppBillingCustomerMutation, { data, loading, error }] = useCreateOrUpdateAppBillingCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateAppBillingCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAppBillingCustomerMutation, CreateOrUpdateAppBillingCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAppBillingCustomerMutation, CreateOrUpdateAppBillingCustomerMutationVariables>(CreateOrUpdateAppBillingCustomerDocument, options);
      }
export type CreateOrUpdateAppBillingCustomerMutationHookResult = ReturnType<typeof useCreateOrUpdateAppBillingCustomerMutation>;
export type CreateOrUpdateAppBillingCustomerMutationResult = Apollo.MutationResult<CreateOrUpdateAppBillingCustomerMutation>;
export type CreateOrUpdateAppBillingCustomerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAppBillingCustomerMutation, CreateOrUpdateAppBillingCustomerMutationVariables>;
export const LoadAppBillingProductsDocument = gql`
    query loadAppBillingProducts {
  appBillingProducts(currency: null) {
    ...AppBillingProduct
  }
}
    ${AppBillingProductFragmentDoc}`;

/**
 * __useLoadAppBillingProductsQuery__
 *
 * To run a query within a React component, call `useLoadAppBillingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAppBillingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAppBillingProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadAppBillingProductsQuery(baseOptions?: Apollo.QueryHookOptions<LoadAppBillingProductsQuery, LoadAppBillingProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAppBillingProductsQuery, LoadAppBillingProductsQueryVariables>(LoadAppBillingProductsDocument, options);
      }
export function useLoadAppBillingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAppBillingProductsQuery, LoadAppBillingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAppBillingProductsQuery, LoadAppBillingProductsQueryVariables>(LoadAppBillingProductsDocument, options);
        }
export function useLoadAppBillingProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoadAppBillingProductsQuery, LoadAppBillingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadAppBillingProductsQuery, LoadAppBillingProductsQueryVariables>(LoadAppBillingProductsDocument, options);
        }
export type LoadAppBillingProductsQueryHookResult = ReturnType<typeof useLoadAppBillingProductsQuery>;
export type LoadAppBillingProductsLazyQueryHookResult = ReturnType<typeof useLoadAppBillingProductsLazyQuery>;
export type LoadAppBillingProductsSuspenseQueryHookResult = ReturnType<typeof useLoadAppBillingProductsSuspenseQuery>;
export type LoadAppBillingProductsQueryResult = Apollo.QueryResult<LoadAppBillingProductsQuery, LoadAppBillingProductsQueryVariables>;
export const CreateAppBillingPurchaseDocument = gql`
    mutation createAppBillingPurchase($input: CreateAppBillingPurchaseInput!) {
  createAppBillingPurchase(input: $input) {
    purchase {
      ...AppBillingPurchase
    }
    stripeError {
      ...AppBillingStripeError
    }
  }
}
    ${AppBillingPurchaseFragmentDoc}
${AppBillingStripeErrorFragmentDoc}`;
export type CreateAppBillingPurchaseMutationFn = Apollo.MutationFunction<CreateAppBillingPurchaseMutation, CreateAppBillingPurchaseMutationVariables>;

/**
 * __useCreateAppBillingPurchaseMutation__
 *
 * To run a mutation, you first call `useCreateAppBillingPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppBillingPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppBillingPurchaseMutation, { data, loading, error }] = useCreateAppBillingPurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppBillingPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppBillingPurchaseMutation, CreateAppBillingPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppBillingPurchaseMutation, CreateAppBillingPurchaseMutationVariables>(CreateAppBillingPurchaseDocument, options);
      }
export type CreateAppBillingPurchaseMutationHookResult = ReturnType<typeof useCreateAppBillingPurchaseMutation>;
export type CreateAppBillingPurchaseMutationResult = Apollo.MutationResult<CreateAppBillingPurchaseMutation>;
export type CreateAppBillingPurchaseMutationOptions = Apollo.BaseMutationOptions<CreateAppBillingPurchaseMutation, CreateAppBillingPurchaseMutationVariables>;
export const LoadAppBillingPurchaseDocument = gql`
    query loadAppBillingPurchase($id: String!) {
  appBillingPurchase(id: $id) {
    ...AppBillingPurchase
  }
}
    ${AppBillingPurchaseFragmentDoc}`;

/**
 * __useLoadAppBillingPurchaseQuery__
 *
 * To run a query within a React component, call `useLoadAppBillingPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAppBillingPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAppBillingPurchaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAppBillingPurchaseQuery(baseOptions: Apollo.QueryHookOptions<LoadAppBillingPurchaseQuery, LoadAppBillingPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAppBillingPurchaseQuery, LoadAppBillingPurchaseQueryVariables>(LoadAppBillingPurchaseDocument, options);
      }
export function useLoadAppBillingPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAppBillingPurchaseQuery, LoadAppBillingPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAppBillingPurchaseQuery, LoadAppBillingPurchaseQueryVariables>(LoadAppBillingPurchaseDocument, options);
        }
export function useLoadAppBillingPurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoadAppBillingPurchaseQuery, LoadAppBillingPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadAppBillingPurchaseQuery, LoadAppBillingPurchaseQueryVariables>(LoadAppBillingPurchaseDocument, options);
        }
export type LoadAppBillingPurchaseQueryHookResult = ReturnType<typeof useLoadAppBillingPurchaseQuery>;
export type LoadAppBillingPurchaseLazyQueryHookResult = ReturnType<typeof useLoadAppBillingPurchaseLazyQuery>;
export type LoadAppBillingPurchaseSuspenseQueryHookResult = ReturnType<typeof useLoadAppBillingPurchaseSuspenseQuery>;
export type LoadAppBillingPurchaseQueryResult = Apollo.QueryResult<LoadAppBillingPurchaseQuery, LoadAppBillingPurchaseQueryVariables>;
export const LoadAppBillingPurchasesDocument = gql`
    query loadAppBillingPurchases($whId: [ID!]) {
  appBillingPurchases(
    filter: {warehouseId: $whId, status: [PAID]}
    page: {limit: null}
  ) {
    content {
      ...AppBillingPurchase
    }
  }
}
    ${AppBillingPurchaseFragmentDoc}`;

/**
 * __useLoadAppBillingPurchasesQuery__
 *
 * To run a query within a React component, call `useLoadAppBillingPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAppBillingPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAppBillingPurchasesQuery({
 *   variables: {
 *      whId: // value for 'whId'
 *   },
 * });
 */
export function useLoadAppBillingPurchasesQuery(baseOptions?: Apollo.QueryHookOptions<LoadAppBillingPurchasesQuery, LoadAppBillingPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAppBillingPurchasesQuery, LoadAppBillingPurchasesQueryVariables>(LoadAppBillingPurchasesDocument, options);
      }
export function useLoadAppBillingPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAppBillingPurchasesQuery, LoadAppBillingPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAppBillingPurchasesQuery, LoadAppBillingPurchasesQueryVariables>(LoadAppBillingPurchasesDocument, options);
        }
export function useLoadAppBillingPurchasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoadAppBillingPurchasesQuery, LoadAppBillingPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadAppBillingPurchasesQuery, LoadAppBillingPurchasesQueryVariables>(LoadAppBillingPurchasesDocument, options);
        }
export type LoadAppBillingPurchasesQueryHookResult = ReturnType<typeof useLoadAppBillingPurchasesQuery>;
export type LoadAppBillingPurchasesLazyQueryHookResult = ReturnType<typeof useLoadAppBillingPurchasesLazyQuery>;
export type LoadAppBillingPurchasesSuspenseQueryHookResult = ReturnType<typeof useLoadAppBillingPurchasesSuspenseQuery>;
export type LoadAppBillingPurchasesQueryResult = Apollo.QueryResult<LoadAppBillingPurchasesQuery, LoadAppBillingPurchasesQueryVariables>;
export const CreateAppBillingSubscriptionDocument = gql`
    mutation createAppBillingSubscription($input: CreateAppBillingSubscriptionInput!) {
  createAppBillingSubscription(input: $input) {
    subscription {
      ...AppBillingSubscription
    }
    stripeError {
      ...AppBillingStripeError
    }
  }
}
    ${AppBillingSubscriptionFragmentDoc}
${AppBillingStripeErrorFragmentDoc}`;
export type CreateAppBillingSubscriptionMutationFn = Apollo.MutationFunction<CreateAppBillingSubscriptionMutation, CreateAppBillingSubscriptionMutationVariables>;

/**
 * __useCreateAppBillingSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateAppBillingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppBillingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppBillingSubscriptionMutation, { data, loading, error }] = useCreateAppBillingSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppBillingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppBillingSubscriptionMutation, CreateAppBillingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppBillingSubscriptionMutation, CreateAppBillingSubscriptionMutationVariables>(CreateAppBillingSubscriptionDocument, options);
      }
export type CreateAppBillingSubscriptionMutationHookResult = ReturnType<typeof useCreateAppBillingSubscriptionMutation>;
export type CreateAppBillingSubscriptionMutationResult = Apollo.MutationResult<CreateAppBillingSubscriptionMutation>;
export type CreateAppBillingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateAppBillingSubscriptionMutation, CreateAppBillingSubscriptionMutationVariables>;
export const LoadAppBillingSubscriptionDocument = gql`
    query loadAppBillingSubscription($id: String!) {
  appBillingSubscription(subscriptionId: $id) {
    ...AppBillingSubscription
  }
}
    ${AppBillingSubscriptionFragmentDoc}`;

/**
 * __useLoadAppBillingSubscriptionQuery__
 *
 * To run a query within a React component, call `useLoadAppBillingSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAppBillingSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAppBillingSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAppBillingSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<LoadAppBillingSubscriptionQuery, LoadAppBillingSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAppBillingSubscriptionQuery, LoadAppBillingSubscriptionQueryVariables>(LoadAppBillingSubscriptionDocument, options);
      }
export function useLoadAppBillingSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAppBillingSubscriptionQuery, LoadAppBillingSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAppBillingSubscriptionQuery, LoadAppBillingSubscriptionQueryVariables>(LoadAppBillingSubscriptionDocument, options);
        }
export function useLoadAppBillingSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoadAppBillingSubscriptionQuery, LoadAppBillingSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadAppBillingSubscriptionQuery, LoadAppBillingSubscriptionQueryVariables>(LoadAppBillingSubscriptionDocument, options);
        }
export type LoadAppBillingSubscriptionQueryHookResult = ReturnType<typeof useLoadAppBillingSubscriptionQuery>;
export type LoadAppBillingSubscriptionLazyQueryHookResult = ReturnType<typeof useLoadAppBillingSubscriptionLazyQuery>;
export type LoadAppBillingSubscriptionSuspenseQueryHookResult = ReturnType<typeof useLoadAppBillingSubscriptionSuspenseQuery>;
export type LoadAppBillingSubscriptionQueryResult = Apollo.QueryResult<LoadAppBillingSubscriptionQuery, LoadAppBillingSubscriptionQueryVariables>;
export const LoadAppBillingSubscriptionsDocument = gql`
    query loadAppBillingSubscriptions($whId: [ID!]) {
  appBillingSubscriptions(
    filter: {warehouseId: $whId, status: [ACTIVE, PAST_DUE, UNPAID]}
  ) {
    content {
      ...AppBillingSubscription
    }
  }
}
    ${AppBillingSubscriptionFragmentDoc}`;

/**
 * __useLoadAppBillingSubscriptionsQuery__
 *
 * To run a query within a React component, call `useLoadAppBillingSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAppBillingSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAppBillingSubscriptionsQuery({
 *   variables: {
 *      whId: // value for 'whId'
 *   },
 * });
 */
export function useLoadAppBillingSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<LoadAppBillingSubscriptionsQuery, LoadAppBillingSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAppBillingSubscriptionsQuery, LoadAppBillingSubscriptionsQueryVariables>(LoadAppBillingSubscriptionsDocument, options);
      }
export function useLoadAppBillingSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAppBillingSubscriptionsQuery, LoadAppBillingSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAppBillingSubscriptionsQuery, LoadAppBillingSubscriptionsQueryVariables>(LoadAppBillingSubscriptionsDocument, options);
        }
export function useLoadAppBillingSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoadAppBillingSubscriptionsQuery, LoadAppBillingSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadAppBillingSubscriptionsQuery, LoadAppBillingSubscriptionsQueryVariables>(LoadAppBillingSubscriptionsDocument, options);
        }
export type LoadAppBillingSubscriptionsQueryHookResult = ReturnType<typeof useLoadAppBillingSubscriptionsQuery>;
export type LoadAppBillingSubscriptionsLazyQueryHookResult = ReturnType<typeof useLoadAppBillingSubscriptionsLazyQuery>;
export type LoadAppBillingSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useLoadAppBillingSubscriptionsSuspenseQuery>;
export type LoadAppBillingSubscriptionsQueryResult = Apollo.QueryResult<LoadAppBillingSubscriptionsQuery, LoadAppBillingSubscriptionsQueryVariables>;
export const LoadBillingStateDocument = gql`
    query loadBillingState($warehouseTokens: [ID!]!) {
  appBillingWarehouseStates(warehouseTokens: $warehouseTokens) {
    ...AppBillingWarehouseState
  }
}
    ${AppBillingWarehouseStateFragmentDoc}`;

/**
 * __useLoadBillingStateQuery__
 *
 * To run a query within a React component, call `useLoadBillingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadBillingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadBillingStateQuery({
 *   variables: {
 *      warehouseTokens: // value for 'warehouseTokens'
 *   },
 * });
 */
export function useLoadBillingStateQuery(baseOptions: Apollo.QueryHookOptions<LoadBillingStateQuery, LoadBillingStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadBillingStateQuery, LoadBillingStateQueryVariables>(LoadBillingStateDocument, options);
      }
export function useLoadBillingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadBillingStateQuery, LoadBillingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadBillingStateQuery, LoadBillingStateQueryVariables>(LoadBillingStateDocument, options);
        }
export function useLoadBillingStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoadBillingStateQuery, LoadBillingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadBillingStateQuery, LoadBillingStateQueryVariables>(LoadBillingStateDocument, options);
        }
export type LoadBillingStateQueryHookResult = ReturnType<typeof useLoadBillingStateQuery>;
export type LoadBillingStateLazyQueryHookResult = ReturnType<typeof useLoadBillingStateLazyQuery>;
export type LoadBillingStateSuspenseQueryHookResult = ReturnType<typeof useLoadBillingStateSuspenseQuery>;
export type LoadBillingStateQueryResult = Apollo.QueryResult<LoadBillingStateQuery, LoadBillingStateQueryVariables>;